import React, { useCallback, useRef, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SearchWrap,{FunctionContent,FunctionContentRow} from '../Wrap/SearchWrap'
import SearchCalendar from '../../Common/Atoms/Calendar'
import Button from '../../Common/Atoms/NormalButton'
import { useAlert } from 'react-alert'
import { AiFillPlusCircle, AiFillMinusCircle } from 'react-icons/ai'
import PropTypes from 'prop-types'
import Tooltip from '@material-ui/core/Tooltip'
import { PostApi } from '../../Common/ApiAxios'
import IconFunctionImg from '../../../image/three-reader-vertical-icon.png'
import IconUpdateImg from '../../../image/update-icon.png'
import IconCloseImg from '../../../image/close_icon.png'
import IconPageTypeChange from '../../../image/page-type-change-icon.png'

const Search = (props) => {
  const dispatch = useDispatch()
  const [renderFlg, setRenderFlg] = useState(false)
  const [plusButton, setPlusButton] = useState(false)
  const {
    title, showButton, onClick, onKeyDown, startDateRef, endDateRef, firstSearch, grants,
    inSubChildren,
    addStyle, children, relationStatus,
    onClickFunction,onUpadate,onPageTypeChangeClick,viewFunction
  } = props
  const alert = useAlert()
  const loginUserInfo = useSelector(state => state.loginUserInfo)

  // 初期値
  useEffect(() => {
  // 必要なデータが更新された場合のみ実行
  // eslint-disable-next-line
  }, [loginUserInfo, dispatch])

  // レンダー終了判定

  // 初期検索
  useEffect(() => {
    if (renderFlg && firstSearch) {
      onClick()
    }
  }, [renderFlg, firstSearch, onClick])

  const changeCalendarStart = (date) => {
    startDateRef.current = date;
    onClick()
    //if (!date) {
      //dispatch(SetWorkDate(null))
    //  return null
    //}
    //if (startDateRef !== date) {
    //    startDateRef.current = date;
      //dispatch(SetWorkDate(date))
    //}
  }

  const changeCalendarEnd = (date) => {
    endDateRef.current = date;
    onClick()
    //if (!date) {
      //dispatch(SetWorkDate(null))
    //  return null
    //}
    //if (startDateRef !== date) {
    //    endDateRef.current = date;
      //dispatch(SetWorkDate(date))
    //}
  }

  useEffect(() => {
  // 必要なデータが更新された場合のみ実行
  // eslint-disable-next-line
  }, [loginUserInfo, relationStatus])

  async function logout () {
    const apiUrl = '/api/logout'
    await PostApi(apiUrl, null)
    document.cookie = 'accessToken=;path=/; max-age=0;'
    document.cookie = 'refreshToken=;path=/; max-age=0;'
    document.cookie = 'accessTokenExpires=;path=/; max-age=0;'
    document.cookie = 'refreshTokenExpires=;path=/; max-age=0;'
    window.location.href = '/login'
  }
  
  const viewSubSearch = false
  return (
    <SearchWrap addStyle={addStyle} plusButton={plusButton} viewSubSearch={viewSubSearch} viewFunction={viewFunction}>
      <h3>{title}</h3>
      <ul className='mainSearch'>
        <li>
          <label>期間</label>
          <SearchCalendar changeCalendar={changeCalendarStart} dataValue={startDateRef.current} isViewIcon />
          <label>～</label>
          <SearchCalendar changeCalendar={changeCalendarEnd} dataValue={endDateRef.current} isViewIcon />
        </li>
      </ul>
      {/* {showButton && <Button margin='0 0 0 16px' name='検索' padding='0px' onClick={onClick} />} */}
      <Tooltip title={'機能メニュー'}>
        <img src={IconFunctionImg} width="24px" height="24px" style={{marginLeft: 'auto', cursor: 'pointer'}} onClick={onClickFunction} />
      </Tooltip>
      <li className='mainFunction'>
          <FunctionContent>
            <label style={{height: '12px'}}></label>
            <FunctionContentRow onClick={onUpadate}>
              <img src={IconUpdateImg} width="20px" height="20px" style={{margin: '0 0 3px 12px'}}/>
              <label style={{width:'6rem',marginLeft: '12px',marginTop: '4px'}}>更新</label>
            </FunctionContentRow>
            <hr/>
            {/* <FunctionContentRow>
              <img src={IconUploadImg} width="24px" height="24px" style={{marginLeft: '12px'}}/>
              <label style={{width:'6rem',marginLeft: '12px',marginTop: '4px'}}>アップロード</label>
            </FunctionContentRow>
            <FunctionContentRow onClick={onExport} >
              <img src={IconDownloadImg} width="24px" height="24px"style={{marginLeft: '12px'}}  />
              <label style={{width:'6rem',marginLeft: '12px',marginTop: '4px'}}>ダウンロード</label>
            </FunctionContentRow> */}
            <FunctionContentRow onClick={onPageTypeChangeClick}>
              <img src={IconPageTypeChange} width="20px" height="20px"style={{marginLeft: '12px'}}  />
              <label style={{width:'6rem',marginLeft: '12px',marginTop: '3px'}}>表示切替</label>
            </FunctionContentRow>
            <hr/>
            <FunctionContentRow onClick={logout}>
              <img src={IconCloseImg} width="18px" height="18px" style={{marginLeft: '16px'}}  />
              <label style={{width:'6rem',marginLeft: '12px',marginTop: '2px'}}>ログアウト</label>
            </FunctionContentRow>
            <label style={{height: '12px'}}></label>
          </FunctionContent>
      </li>
    </SearchWrap>
  )
}

Search.propTypes = {
  title: PropTypes.string, // タイトル
  showButton: PropTypes.bool, // 検索ボタン表示
  onClick: PropTypes.func, // 検索処理
  onKeyDown: PropTypes.func, // キーダウン処理
  startDateRef: PropTypes.object, // 検索項目関連
  endDateRef: PropTypes.object, // 検索項目関連
  firstSearch: PropTypes.bool, // 最初に検索処理をするか
  grants: PropTypes.object, // 権限関連
  inSubChildren: PropTypes.bool, // その他メニューをサブメニューに表示 メインには表示しない
  addStyle: PropTypes.string, // css用追加用
  children: PropTypes.any, // 子要素
}

export default Search
